import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { PredefinedTabSection } from './constants';
import { DateRangePickerTimeUnit } from '../../constants';

export const LastSection = defineMessages({
  valuePlaceholder: {
    id: `components.form.date_range_picker.tab.predefined.section.last.value_placeholder`,
  },
  unitPlaceholder: {
    id: `components.form.date_range_picker.tab.predefined.section.last.unit_placeholder`,
  },
});

export const PredefinedTabSectionTranslated: Record<PredefinedTabSection, MessageDescriptor> = defineMessages({
  [PredefinedTabSection.Last]: {
    id: `components.form.date_range_picker.tab.predefined.section.last`,
  },
  [PredefinedTabSection.Predefined]: {
    id: `components.form.date_range_picker.tab.predefined.section.predefined`,
  },
  [PredefinedTabSection.Year]: {
    id: `components.form.date_range_picker.tab.predefined.section.year`,
  },
});

export const TimeUnitTranslated: Record<DateRangePickerTimeUnit, MessageDescriptor> = defineMessages({
  [DateRangePickerTimeUnit.Hour]: {
    id: `components.form.date_range_picker.tab.predefined.time_unit.hour`,
  },
  [DateRangePickerTimeUnit.Day]: {
    id: `components.form.date_range_picker.tab.predefined.time_unit.day`,
  },
  [DateRangePickerTimeUnit.Week]: {
    id: `components.form.date_range_picker.tab.predefined.time_unit.week`,
  },
  [DateRangePickerTimeUnit.Month]: {
    id: `components.form.date_range_picker.tab.predefined.time_unit.month`,
  },
  [DateRangePickerTimeUnit.Year]: {
    id: `components.form.date_range_picker.tab.predefined.time_unit.year`,
  },
});
